import React from "react";
import {
  IonSearchbar,
  IonSelect,
  IonSelectOption,
  IonSpinner,
} from "@ionic/react";
import { useDispatch } from "react-redux";
import MonthYearPicker from "../../components/MonthYearPicker";
import { setVisitsFilter } from "./visitsSlice";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

const Header = (props) => {
  const { visitsFilter, onSearch, searchValue, loading } = props;
  const intl = useIntl();
  const dispatch = useDispatch();
  const { summary } = useSelector((state) => state.visits);
  let title = null;

  switch (visitsFilter) {
    case "all":
      title = summary.all !== undefined && `${summary.all} ביקורים`;
      break;
    case "done":
      title =
        summary.completed !== undefined &&
        `${summary.completed}/${summary.all} בוצעו`;
      break;
    case "scheduled":
      title = summary.scheduled !== undefined && `${summary.scheduled} לביצוע`;
      break;
    case "missing":
      title = summary.missed !== undefined && `${summary.missed} לא בוצעו`;
      break;
    default:
      break;
  }

  return (
    <div className="stick_to_top">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "0px 12px 0 12px",
        }}
      >
        <MonthYearPicker />
        {loading ? (
          <IonSpinner />
        ) : (
          <IonSelect
            value={visitsFilter}
            onIonChange={(e) => dispatch(setVisitsFilter(e.detail.value))}
            interface="action-sheet"
          >
            <IonSelectOption value="all">
              {intl.formatMessage({
                id: "app.mobile.filters.all",
              })}
            </IonSelectOption>
            <IonSelectOption value="done">
              {intl.formatMessage({
                id: "app.mobile.filters.done_visits",
              })}
            </IonSelectOption>
            <IonSelectOption value="scheduled">
              {intl.formatMessage({
                id: "app.mobile.filters.scheduled_visits",
              })}
            </IonSelectOption>
            <IonSelectOption value="missing">
              {intl.formatMessage({
                id: "app.mobile.filters.missing_visits",
              })}
            </IonSelectOption>
          </IonSelect>
        )}
      </div>
      <IonSearchbar
        // value={searchValue}
        onIonChange={(e) => onSearch(e.detail.value)}
        placeholder={intl.formatMessage({
          id: "app.mobile.search_by_patient_name",
        })}
      ></IonSearchbar>
      {title && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "30px",
          }}
        >
          <p
            style={{
              padding: "0 12px",
              margin: "0 0 4px 0",
              fontWeight: "bold",
            }}
          >
            {title}
          </p>
        </div>
      )}
    </div>
  );
};

export default Header;
